'use client';

import { c as _c } from "react/compiler-runtime";
import type { ComponentProps } from 'react';
import { Button } from '@repo/ui/components';
import { cn } from '@repo/ui/lib/utils';
import { ArrowDownIcon } from 'lucide-react';
import { useCallback } from 'react';
import { StickToBottom, useStickToBottomContext } from 'use-stick-to-bottom';
export type AIConversationProps = ComponentProps<typeof StickToBottom>;
export const AIConversation = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("relative flex-1 overflow-y-auto", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <StickToBottom className={t1} initial="smooth" resize="smooth" role="log" {...props} data-sentry-element="StickToBottom" data-sentry-component="AIConversation" data-sentry-source-file="conversation.tsx" />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export type AIConversationContentProps = ComponentProps<typeof StickToBottom.Content>;
export const AIConversationContent = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("p-4", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <StickToBottom.Content className={t1} {...props} data-sentry-element="StickToBottom.Content" data-sentry-component="AIConversationContent" data-sentry-source-file="conversation.tsx" />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export const AIConversationScrollButton = () => {
  const $ = _c(5);
  const {
    isAtBottom,
    scrollToBottom
  } = useStickToBottomContext();
  let t0;
  if ($[0] !== scrollToBottom) {
    t0 = () => {
      scrollToBottom();
    };
    $[0] = scrollToBottom;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleScrollToBottom = t0;
  let t1;
  if ($[2] !== handleScrollToBottom || $[3] !== isAtBottom) {
    t1 = !isAtBottom && <Button className="absolute bottom-4 left-[50%] translate-x-[-50%] rounded-full" onClick={handleScrollToBottom} size="icon" type="button" variant="outline"><ArrowDownIcon className="size-4" /></Button>;
    $[2] = handleScrollToBottom;
    $[3] = isAtBottom;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};